import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  handleGoToDashboard = () => {
    window.location.href = '/dashboard/deals'
  }

  handleLogin = () => {
    window.location.href = '/login'
  }

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || ''
      const isAuthRelated = errorMsg.toLowerCase().includes('unauthorized') ||
        errorMsg.toLowerCase().includes('forbidden') ||
        errorMsg.toLowerCase().includes('session')

      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          textAlign: 'center',
          backgroundColor: '#f9fafb'
        }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#111827', marginBottom: '0.5rem' }}>
            {isAuthRelated ? 'Session expired' : 'Something went wrong'}
          </h1>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: '400px' }}>
            {isAuthRelated
              ? 'Your session has expired. Please log in again to continue.'
              : 'An unexpected error occurred. Please try reloading the page.'}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            {isAuthRelated ? (
              <button
                onClick={this.handleLogin}
                style={{
                  padding: '0.5rem 1.5rem',
                  backgroundColor: '#4f46e5',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  cursor: 'pointer'
                }}
              >
                Log in again
              </button>
            ) : (
              <>
                <button
                  onClick={this.handleGoToDashboard}
                  style={{
                    padding: '0.5rem 1.5rem',
                    backgroundColor: '#ffffff',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    cursor: 'pointer'
                  }}
                >
                  Return to Dashboard
                </button>
                <button
                  onClick={this.handleReload}
                  style={{
                    padding: '0.5rem 1.5rem',
                    backgroundColor: '#4f46e5',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.375rem',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    cursor: 'pointer'
                  }}
                >
                  Reload Page
                </button>
              </>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
